<div class="error-image">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 432 329" fill="none">
    <path
      fill="#E3F2FD"
      d="M216 328.547C98.943 328.547.043 316.851.043 303.007s98.9-25.539 215.957-25.539c117.057 0 215.957 11.7 215.957 25.539 0 13.839-98.9 25.54-215.957 25.54Z" />
    <path
      fill="#fff"
      stroke="#0071BB"
      stroke-width="2"
      d="M80.02 301.849a15.18 15.18 0 0 1-15.16-15.16V83.829a15.2 15.2 0 0 1 15.16-15.206h264.399a15.2 15.2 0 0 1 15.159 15.206v202.86a15.173 15.173 0 0 1-15.159 15.16h-264.4Z" />
    <path
      fill="#E3F2FD"
      stroke="#0071BB"
      stroke-width="4"
      d="M344.419 69.207a14.615 14.615 0 0 1 14.574 14.621V286.69a14.592 14.592 0 0 1-14.574 14.576h-264.4a14.59 14.59 0 0 1-14.574-14.576V83.829A14.614 14.614 0 0 1 80.02 69.207h264.4Zm0-1.168h-264.4a15.77 15.77 0 0 0-15.743 15.79v202.86a15.733 15.733 0 0 0 15.743 15.744h264.4a15.719 15.719 0 0 0 11.136-4.607 15.736 15.736 0 0 0 4.607-11.137V83.829a15.768 15.768 0 0 0-15.743-15.79Z" />
    <path
      fill="#E3F2FD"
      stroke="#0071BB"
      stroke-width="2"
      d="M64.86 121.169v-37.34a15.2 15.2 0 0 1 15.16-15.205h264.399a15.2 15.2 0 0 1 15.16 15.206v37.34l-294.719-.001Z" />
    <path
      fill="#000"
      stroke="#0071BB"
      stroke-width="2"
      d="M344.419 69.207a14.615 14.615 0 0 1 14.574 14.621v36.755H65.445V83.828a14.614 14.614 0 0 1 14.574-14.62h264.4Zm0-1.168h-264.4a15.77 15.77 0 0 0-15.743 15.79v37.923h295.886V83.828a15.768 15.768 0 0 0-15.743-15.79Z" />
    <path fill="#E3F2FD" d="M143.088 102.89a7 7 0 1 1 7-7 7.01 7.01 0 0 1-7 7Z" />
    <path
      fill="#000"
      stroke="#0071BB"
      stroke-width="2"
      d="M143.088 89.466a6.416 6.416 0 1 1-6.417 6.418 6.425 6.425 0 0 1 6.417-6.418Zm0-1.168a7.59 7.59 0 0 0-7.009 4.682 7.585 7.585 0 0 0 5.529 10.344 7.593 7.593 0 0 0 7.787-3.226 7.583 7.583 0 0 0-.943-9.578 7.588 7.588 0 0 0-5.364-2.222Z" />
    <path
      fill="#E3F2FD"
      d="M120.064 102.89a7.005 7.005 0 0 1-6.467-4.322 7 7 0 1 1 13.467-2.678 7.008 7.008 0 0 1-7 7Z" />
    <path
      fill="#000"
      stroke="#0071BB"
      stroke-width="2"
      d="M120.063 89.466a6.419 6.419 0 0 1 6.293 7.67 6.415 6.415 0 0 1-11.629 2.313 6.418 6.418 0 0 1-1.081-3.566 6.424 6.424 0 0 1 6.417-6.416Zm0-1.168a7.587 7.587 0 1 0 0 15.173 7.587 7.587 0 0 0 0-15.174Z" />
    <path
      fill="#E3F2FD"
      d="M97.04 102.89a7.001 7.001 0 0 1-1.367-13.866 7 7 0 0 1 8.366 6.865 7.01 7.01 0 0 1-7 7.001Z" />
    <path
      fill="#000"
      stroke="#0071BB"
      stroke-width="2"
      d="M97.04 89.466a6.416 6.416 0 1 1-6.418 6.418 6.425 6.425 0 0 1 6.417-6.418Zm0-1.168a7.586 7.586 0 1 0 0 15.17 7.586 7.586 0 0 0 0-15.17Z" />
    <path
      fill="#E3F2FD"
      stroke="#0071BB"
      stroke-width="4"
      d="m319.895 105.467-.175-.207a62.477 62.477 0 1 1 25.233 17.937l-.224-.085-29.932 13 5.098-30.645Z" />
    <path
      fill="#000"
      stroke="#0071BB"
      stroke-width="2"
      d="M367.479 2.622a62.083 62.083 0 1 1-22.315 120.031l-.447-.172-.439.191-28.728 12.481 4.879-29.321.089-.535-.352-.413A62.067 62.067 0 0 1 367.479 2.622Zm0-1.169a63.242 63.242 0 0 0-57.404 36.685 63.234 63.234 0 0 0 9.203 67.5l-5.23 31.44 30.7-13.335a63.252 63.252 0 0 0 74.127-22.151 63.248 63.248 0 0 0 9.82-52.83 63.26 63.26 0 0 0-61.216-47.309Z" />
    <path
      stroke="#0071BB"
      stroke-miterlimit="10"
      stroke-width="3"
      d="M351.003 37.745a29.68 29.68 0 0 1 46.273 24.608c0 2.24.471 7.708 0 9.806M384.737 86.582a29.689 29.689 0 0 1-45.7-32.317" />
    <path
      stroke="#0071BB"
      stroke-miterlimit="10"
      stroke-width="3"
      d="m386.481 61.133 9.01 12.339 11.948-10.381M327.518 62.069l12.618-8.617 7.789 13.779" />
    <path fill="#fff" d="M36.724 75.447a40.168 40.168 0 0 1 29.82-31.672" />
    <path stroke="#0071BB" stroke-width="2" d="M36.724 75.447a40.168 40.168 0 0 1 29.82-31.672" />
    <path
      stroke="#0071BB"
      stroke-miterlimit="10"
      stroke-width="4"
      d="M36.724 75.447a40.168 40.168 0 0 1 29.82-31.672" />
    <path fill="#fff" d="M10.007 71.049A67.189 67.189 0 0 1 57.283 18.26" />
    <path stroke="#0071BB" stroke-width="2" d="M10.007 71.049A67.189 67.189 0 0 1 57.283 18.26" />
    <path
      stroke="#0071BB"
      stroke-miterlimit="10"
      stroke-width="4"
      d="M10.007 71.049A67.189 67.189 0 0 1 57.283 18.26" />
    <path
      stroke="#0071BB"
      stroke-width="3"
      d="M265.43 175.624a7.442 7.442 0 1 1-7.443 7.443 7.455 7.455 0 0 1 7.443-7.443Zm0-1.356a8.799 8.799 0 0 0-8.13 5.433 8.795 8.795 0 0 0 1.907 9.59 8.795 8.795 0 0 0 4.506 2.408 8.794 8.794 0 0 0 9.034-3.741 8.804 8.804 0 0 0-1.095-11.112 8.81 8.81 0 0 0-6.222-2.578ZM158.889 175.624a7.442 7.442 0 1 1-7.443 7.443 7.455 7.455 0 0 1 7.443-7.443Zm0-1.356a8.799 8.799 0 0 0-8.13 5.433 8.795 8.795 0 0 0 1.907 9.59 8.795 8.795 0 0 0 4.506 2.408 8.794 8.794 0 0 0 9.034-3.741 8.804 8.804 0 0 0-1.095-11.112 8.81 8.81 0 0 0-6.222-2.578Z" />
    <path
      fill="#fff"
      d="M237.201 242.231a29.037 29.037 0 0 0-25.725-15.573 29.035 29.035 0 0 0-25.724 15.573" />
    <path
      stroke="#0071BB"
      stroke-width="4"
      d="M237.201 242.231a29.037 29.037 0 0 0-25.725-15.573 29.035 29.035 0 0 0-25.724 15.573" />
  </svg>
</div>
<div class="error-content" [attr.data-testid]="testId()">
  <h1 data-testid="global-error-title">
    {{ computedTitle() | translate }}
  </h1>
  <p data-testid="global-error-message">{{ message() | translate }}</p>
  @if (hasReload()) {
    <orbit-button
      data-testid="global-error-reload-button"
      (click)="reload.emit()"
      [label]="'SHARED.ERRORS.GLOBAL.RELOAD' | translate"
      [icon]="refreshIcon"
      [size]="'large'" />
  }
</div>
